import React from 'react';

import { put } from '@redux-saga/core/effects';
import { FormattedMessage } from 'react-intl';
import { call } from 'redux-saga/effects';

import * as actions from '@actions/savedFilingPeriod';
import { createConversion } from '@api/mapping';
import { listSavedFilingPeriodFiles } from '@api/savedFilingPeriod';
import { CATEGORY_CHOICES } from '@constants/vatReturns';
import { fileListModel } from '@models/FileList/fileListModel';
import {
  convertFailure,
  convertSuccess,
} from '@store/conversionTool/postConversion/postConversion.reducer';
import { toastError, toastSuccess } from '@store/notifications';

export const convertRequestSaga = function* ({ payload }) {
  try {
    const requestData = {
      uploaded_file: payload.uploadedFile,
      sheet_maps: Object.values(payload.sheetMaps).map(item => ({
        sheet_name: item.sheetId,
        mapping: item.mapping,
      })),
    };
    const conversionToolResponse = yield call(createConversion, requestData);
    const savedFilingPeriodPayload = {
      id: payload?.filingPeriodId,
      categories: [CATEGORY_CHOICES.POST_CONVERSION],
    };
    const response = yield call(listSavedFilingPeriodFiles, savedFilingPeriodPayload);
    yield put([
      convertSuccess(conversionToolResponse),
      actions.listSavedFilingPeriodFilesSuccess({
        files: fileListModel(response.results),
      }),
      toastSuccess({
        message: (
          <FormattedMessage
            defaultMessage="File converted successfully."
            id="pages.upload-data.conversion-tool.conversion.success"
          />
        ),
      }),
    ]);

    if (payload.onSuccess) yield call(payload.onSuccess);
  } catch (errors) {
    const { nonFieldErrors, hasNonFieldError } = errors.data || {};
    yield put([
      convertFailure(),
      toastError({
        message: hasNonFieldError ? (
          nonFieldErrors
        ) : (
          <FormattedMessage
            defaultMessage="An unexpected error occurred, please try again."
            id="global.notification.api-error-default"
          />
        ),
      }),
    ]);
  }
};
